import { ActionContext, ActionExecutor } from '../baseAction.types'
import { OverlayAction } from './overlayAction.types'

export class OverlayActionExecutor implements ActionExecutor {
  execute(action: OverlayAction, { showOverlay }: ActionContext) {
    showOverlay(action)
  }
}
